export const isSafeNumber = (x: unknown): x is number =>
  typeof x === 'number' &&
  x <= Number.MAX_SAFE_INTEGER &&
  x >= Number.MIN_SAFE_INTEGER;
